/**
 * Los avisos del borrado de un documento, en un solo lugar para las dos bibliotecas.
 *
 * Existen por dos razones concretas, no para ahorrar líneas:
 *
 * 1. **El aviso de éxito dice lo que REALMENTE se borró**, no lo que el diálogo había prometido. El
 *    backend devuelve los números ejecutados (`data.facts/notes/events`) justamente para eso: entre
 *    que se abrió la confirmación y se apretó el botón, un hecho pudo aprobarse, fusionarse o
 *    rechazarse, y el usuario se quedaba creyendo que se llevó 13 cuando se llevaron 9 (review
 *    C-borrado-08). Si el backend no manda los números —deploy viejo—, cae al texto de siempre.
 * 2. **El rechazo por documento en proceso tiene su propio texto.** Un 409 `DOCUMENT_IN_FLIGHT` no
 *    es «se produjo un error»: es «esperá a que termine de leerse», y decirlo mal manda a la persona
 *    a soporte por algo que se resuelve en un minuto.
 */

export const DELETE_IN_FLIGHT = 'DOCUMENT_IN_FLIGHT';

// El backend cuenta el resumen como `notes`; para el usuario es «el resumen» y no una cantidad.
function partsOf(t, done) {
    const parts = [];
    if (done.facts) {
        parts.push(t(done.facts === 1
            ? 'client_memory.documents.delete_count_facts_one'
            : 'client_memory.documents.delete_count_facts_many', {n: done.facts}));
    }
    if (done.notes) {
        parts.push(t(done.notes === 1
            ? 'client_memory.documents.delete_count_notes_one'
            : 'client_memory.documents.delete_count_notes_many', {n: done.notes}));
    }
    if (done.events) {
        parts.push(t(done.events === 1
            ? 'client_memory.documents.delete_count_events_one'
            : 'client_memory.documents.delete_count_events_many', {n: done.events}));
    }
    return parts;
}

/**
 * El aviso de éxito. `done` es el `data` de la respuesta: puede no venir (backend viejo) y ahí se
 * cae al texto genérico, que sigue siendo cierto.
 */
export function deletedMessage(t, withExtracted, done) {
    if (!withExtracted) return t('client_memory.documents.delete_ok');
    const parts = done ? partsOf(t, done) : [];
    if (!parts.length) return t('client_memory.documents.delete_ok_with_extracted');
    const kept = done.facts_kept
        ? ' ' + t(done.facts_kept === 1
            ? 'client_memory.documents.delete_kept_one'
            : 'client_memory.documents.delete_kept_many', {n: done.facts_kept})
        : '';
    return t('client_memory.documents.delete_ok_detail', {
        items: parts.join(', '),
        interpolation: {escapeValue: false},
    }) + kept;
}

/** El aviso de error: el 409 del documento en proceso se nombra; el resto cae al genérico. */
export function deleteErrorMessage(t, data) {
    const code = data && (data.reason_code || data.error_code);
    return code === DELETE_IN_FLIGHT
        ? t('client_memory.documents.delete_in_flight')
        : t('client_memory.toast.error');
}
